<template>
  <div class="header-logo" @click="$router.replace({ name: 'home' }).catch(() => {})">
    <img :src="logo" class="header-logo__img" alt="logo" />
    <img :src="logoMobile" class="header-logo__img--sm" alt="logo" />
  </div>
</template>

<script>
import config from "@/sites/config.json"
export default {
  name: "AppHeaderMenuLogo",
  computed: {
    logo() {
      return this.site.pages.home.logo
    },
    logoMobile() {
      // Ícone compacto para o mobile; sites white-label caem no icon do config
      if (this.siteKey === 'default') {
        return '/img/maisenvios-icon.png';
      }
      return this.site.icon || this.site.pages.home.logo;
    }
  },
  data() {
    return {
      site: config["default"],
      siteKey: "default",
    };
  },
  mounted() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const site = parts.length === 4 ? parts[0] : 'default';
    this.siteKey = config[site] ? site : 'default';
    this.site = config[this.siteKey];
  }
};
</script>
<style>
/* div simples (não el-menu-item/el-link): sem border-bottom nem
   sublinhado no hover, sem estados de menu. */
.header-logo {
  float: left;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 12px;
  cursor: pointer;
}

.header-logo__img {
  height: 36px;
}

.header-logo__img--sm {
  display: none;
  height: 30px;
}

@media only screen and (max-width: 767px) {
  .header-logo__img {
    display: none;
  }

  .header-logo__img--sm {
    display: block;
  }

  .header-logo {
    padding: 0 6px;
  }
}
</style>
